import { useState } from 'react';
import type { OtaFormState, PropertyOpt } from './otaTypes';
import './OtaReservationForm.css';

import { tx } from '../../lib/adminI18n';
// OTA予約の手動登録フォーム（表示のみ）。
//   3画面（予約管理・パスポート・チェックイン）で同一のマークアップを共通化したもの。
//   送信ロジック(submitOta)と state は呼び出し側に残し、props で受け取る。
//   見た目を変えないため、元の inline style / className(pp-*) をそのまま踏襲する。
interface Props {
  form: OtaFormState;
  properties: PropertyOpt[];
  onChange: (next: OtaFormState) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const OTA_OPTIONS = [
  { value: 'airbnb', label: () => 'Airbnb' },
  { value: 'booking', label: () => 'Booking.com' },
  { value: 'other_ota', label: () => tx('ota.0') },
];

export default function OtaReservationForm({ form, properties, onChange, onSubmit }: Props) {
  // 物件はボタン選択なので required 属性が効かない → 送信時に自前でチェック
  const [propErr, setPropErr] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    if (!form.property_id) { e.preventDefault(); setPropErr(true); return; }
    onSubmit(e);
  };
  return (
    <form onSubmit={handleSubmit} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '1.25rem', margin: '1rem 0', display: 'grid', gap: '.75rem', gridTemplateColumns: '1fr 1fr' }}>
      {/* OTA選択：プルダウン → ブランド色付きの大きなボタン */}
      <div className="ota-field" style={{ gridColumn: '1 / -1' }}>
        <span className="ota-field-label">OTA</span>
        <div className="ota-choice-row" role="radiogroup" aria-label="OTA">
          {OTA_OPTIONS.map((o) => (
            <button key={o.value} type="button" role="radio" aria-checked={form.source_channel === o.value}
              className={`ota-choice ota-choice-${o.value} ${form.source_channel === o.value ? 'is-selected' : ''}`}
              onClick={() => onChange({ ...form, source_channel: o.value })}>
              <span className="ota-choice-dot" />{o.label()}
            </button>
          ))}
        </div>
      </div>
      {/* 物件選択：プルダウン → カード一覧（1〜10件想定） */}
      <div className="ota-field" style={{ gridColumn: '1 / -1' }}>
        <span className="ota-field-label">{tx('ota.1')} <span className="ota-required">*</span></span>
        {properties.length === 0 ? (
          <div className="ota-empty">{tx('ota.2')}</div>
        ) : (
          <div className="ota-property-grid" role="radiogroup" aria-label={tx('ota.1')}>
            {properties.map((p) => (
              <button key={p.id} type="button" role="radio" aria-checked={form.property_id === p.id}
                className={`ota-property ${form.property_id === p.id ? 'is-selected' : ''}`}
                onClick={() => { setPropErr(false); onChange({ ...form, property_id: p.id }); }}>
                <span className="ota-property-check">{form.property_id === p.id ? '✓' : ''}</span>
                <span className="ota-property-name">{p.name}</span>
              </button>
            ))}
          </div>
        )}
        {propErr && <div className="ota-error">⚠ {tx('ota.2')}</div>}
      </div>
      <label className="pp-label">{tx('ota.3')}
        <input className="pp-input" type="date" required value={form.checkin_date} onChange={(e) => onChange({ ...form, checkin_date: e.target.value })} />
      </label>
      <label className="pp-label">{tx('ota.4')}
        <input className="pp-input" type="date" required value={form.checkout_date} onChange={(e) => onChange({ ...form, checkout_date: e.target.value })} />
      </label>
      <label className="pp-label">{tx('ota.5')}
        <input className="pp-input" type="number" min={1} required value={form.guest_count} onChange={(e) => onChange({ ...form, guest_count: Number(e.target.value) })} />
      </label>
      <label className="pp-label">{tx('ota.6')}
        <input className="pp-input" value={form.guest_name} onChange={(e) => onChange({ ...form, guest_name: e.target.value })} />
      </label>
      <label className="pp-label" style={{ gridColumn: '1 / -1' }}>{tx('ota.7')}
        <input className="pp-input" value={form.ota_reservation_code} onChange={(e) => onChange({ ...form, ota_reservation_code: e.target.value })} />
      </label>
      <div style={{ gridColumn: '1 / -1', textAlign: 'right' }}>
        <button type="submit" className="pp-btn">{tx('ota.8')}</button>
      </div>
    </form>
  );
}
